import React, { Component } from "react";
import "react-table-6/react-table.css";
import "react-sweet-progress/lib/style.css";
import $ from "jquery";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Link } from "react-router-dom";
import ParseOutput from "./tabsComponent/ParseOutput";
import MeaningMatchScore from "./tabsComponent/MeaningMatchScore";
import FaqExtraction from "./tabsComponent/FaqExtraction";
import IntentExtraction from "./tabsComponent/IntentExtraction";
import SlotExtraction from "./tabsComponent/SlotExtraction";
import DocExtraction from "./tabsComponent/DocExtraction";

class Test extends Component {
  constructor() {
    super();
    this.runtimeServerMap = {
      "developers.dhee.ai": "https://runtime.dhee.ai",
      "dev-platform.dhee.net.in": "https://dev-runtime.dhee.net.in",
    };
    this.runtimeServer = this.runtimeServerMap[window.location.host];
    this.state = {
      data: [{}],
      developerId: null,
      projectId: null,
      debugClickCount: 0,
      showMeaningMatchScore: false,
      runTimeNodeList: [],
    };
  }
  componentDidMount() {
    var currentPath = window.location.href;
    if (
      currentPath.includes("/Test/meaning-match-score") &&
      this.state.showMeaningMatchScore === false
    ) {
      this.props.history.push("/projectmgmt/test-and-deploy/Test");
    }
    const script = document.createElement("script");
    script.src = this.runtimeServer + "/web-widget/js/main.js";
    script.async = true;
    $(".widget_wrapper").get(0).appendChild(script);
    this.setState(this.state);

    let testControler = this;

    (function () {
      var currentPath = window.location.href;
      var path = window.origin + "/platform/projectmgmt/test-and-deploy/Test";
      var path1 = window.origin + "/platform/projectmgmt/test-and-deploy/Test/";
      if (currentPath === path || currentPath === path1) {
        $("#parse-output").addClass("active");
      } else if (currentPath.includes("/Test/FaqExtraction")) {
        $("#faq-extr").addClass("active");
      } else if (currentPath.includes("/Test/IntentExtraction")) {
        $("#intent-extr").addClass("active");
      } else if (currentPath.includes("/Test/SlotExtraction")) {
        $("#slot-extr").addClass("active");
      } else if (currentPath.includes("/Test/DocExtraction")) {
        $("#doc-extr").addClass("active");
      }else if (currentPath.includes("/Test/meaning-match-score")) {
        $("#matching-score").addClass("active");
      } else {
        $("#" + localStorage.getItem("last-used-debug-tab")).addClass("active");
      }
      $("#parse-output,#faq-extr,#intent-extr,#slot-extr,#doc-extr,#matching-score").on(
        "click",
        function () {
          $(
            "#parse-output,#faq-extr,#intent-extr,#slot-extr,#doc-extr,#matching-score"
          ).removeClass("active");
          localStorage.setItem("last-used-debug-tab", $(this)[0].id);
          $(this).addClass("active");
        }
      );
    })();

    this.loadRuntimes();
    document.addEventListener("projectChanged", function (event) {
      testControler.projectId = event.projectId;
      testControler.state.developerId = JSON.parse(
        localStorage.getItem("user_details")
      ).userId;
      testControler.state.projectId = localStorage.getItem("currentProjectId");
      testControler.loadRuntimes(event.projectId);
      testControler.setState(testControler.state);
    });
  }

  onClickDebugInsight = () => {
    this.state.debugClickCount = this.state.debugClickCount + 1;
    this.setState(this.state);
    if (this.state.debugClickCount == 6) {
      this.state.showMeaningMatchScore = true;
      if (this.state.runTimeNodeList.length > 0) {
        localStorage.setItem(
          "runtimeNodeName",
          this.state.runTimeNodeList[0]["code"]
        );
      }
      this.setState(this.state);
    }
  };

  onclickMouseMoveOut = () => {
    this.state.debugClickCount = 0;
    this.setState(this.state);
  };

  loadRuntimes = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }
    var testControler = this;
    $.ajax({
      url: "/api/runtime-nodes",
      async: false,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        projectId: projectId,
      },
      success: function (res) {
        if (res.success === true) {
          var loadedRunTime = res.result;
          if (loadedRunTime.length > 0) {
            testControler.state.runTimeNodeList = res.result;
            var ele3 = document.getElementById("runTimeDropDown");
            if (ele3 != null) {
              if (ele3 != "") {
                ele3.innerHTML = "";
              }

              for (var i = 0; i < loadedRunTime.length; i++) {
                ele3.innerHTML =
                  ele3.innerHTML +
                  '<option value="' +
                  loadedRunTime[i]["code"] +
                  '">' +
                  loadedRunTime[i]["name"] +
                  "</option>";
              }
              if (testControler.state.showMeaningMatchScore) {
                localStorage.setItem(
                  "runtimeNodeName",
                  document.getElementById("runTimeDropDown").value
                );
              } else {
                localStorage.setItem("runtimeNodeName", null);
              }
            } else {
              localStorage.setItem("runtimeNodeName", null);
            }
          } else {
            localStorage.setItem("runtimeNodeName", null);
          }
        } else {
          localStorage.setItem("runtimeNodeName", null);
        }
      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      },
    });
  };

  handleChangeRunTime = (e) => {
    var runtimeNodeName = document.getElementById("runTimeDropDown").value;
    localStorage.setItem("runtimeNodeName", runtimeNodeName);
  };

  render() {
    this.state.developerId = JSON.parse(
      localStorage.getItem("user_details")
    ).userId;
    this.state.projectId = localStorage.getItem("currentProjectId");
    const { data } = this.state;
    return (
      <div style={{ marginLeft: "1%", marginTop: "2%" }}>
        {/* for toaster */}
        <link rel="stylesheet" href="assets/css/ReactToastify.css" />
        {/* for reactTable */}
        <link
          rel="stylesheet"
          href="assets/css/React_Table_CSS/react-table.css"
        />
        {/*for dialog component */}
        <link href="assets/css/ej2-base.css" rel="stylesheet" />
        <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
        <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
        <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
        <link href="assets/css/screenResolution.css" rel="stylesheet" />
        <link href="assets/css/test-chat.css" rel="stylesheet" />
        <link
          rel="shortcut icon"
          type="image/png"
          href="assets/images/bot.ico"
        />
        <title> Dheeyantra | BackEnd Api </title>
        {/* Font Awesome Icons */}
        <link
          rel="stylesheet"
          href="plugins/font-awesome/css/font-awesome.min.css"
        />
        {/* IonIcons */}
        <link
          rel="stylesheet"
          href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css"
        />
        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
        {/* Theme style */}
        <link rel="stylesheet" href="assets/css/adminlte.css" />
        <link
          href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css"
          rel="stylesheet"
        />
        <link rel="stylesheet" href="plugins/select2/select2.min.css" />
        <link rel="stylesheet" href="assets/css/custom-style.css" />
        <link rel="stylesheet" href="assets/css/styles.css" />
        {/* ----new style------------------------------- */}
        <link
          rel="shortcut icon"
          type="image/png"
          href="assets/images/bot.ico"
        />
        <link
          rel="stylesheet"
          href="plugins/font-awesome/css/font-awesome.min.css"
        />
        <link
          rel="stylesheet"
          href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css"
        />
        <link
          href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css"
          rel="stylesheet"
        />
        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
        <link rel="stylesheet" href="plugins/select2/select2.min.css" />
        <link rel="stylesheet" href="dist/css/adminlte.css" />
        <link rel="stylesheet" href="assets/css/custom-style.css" />
        <link rel="stylesheet" href="assets/css/styles.css" />
        <link
          rel="stylesheet"
          type="text/css"
          href={
            this.runtimeServer +
            "/web-widget/css/styles.css?instanceId=dheepareeksharitham" +
            this.state.projectId
          }
        />
        <link
          rel="stylesheet"
          type="text/css"
          href={this.runtimeServer + "/web-widget/css/mediaQ.css"}
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="./assets/css/widgetOverride.css"
        />
        <style
          media="screen"
          dangerouslySetInnerHTML={{
            __html:
              "\n    .card-footer {\n      background-color: transparent;\n      padding: 0.75rem 0.25rem;\n    }\n\n    .logtable tbody td:last-child{\n      width: 150px;\n    }\n\n    .logTableBox{\n      overflow: auto !important;\n    }\n  ",
          }}
        />

        <link rel="stylesheet" href="./assets/css/configBot.css" />
        <div className="wrapper">
          <div className="content" id="configBotcontainer">
            <div className="container-fluid">
              <div className="row">
                <div
                  className="col-lg-5"
                  style={{ marginTop: "10px", borderRadius: "10px" }}
                >
                  <div className="card_container">
                    <div className="col-lg-12 p-0">
                      {/* <p className="taglineTxt" style={{ color: "black", fontStyle: 'none' }}>
                  Chat and Test your Bot  </p> */}
                      <h6
                        className="nav-item"
                        style={{
                          color: "#282a65",
                          marginLeft: "10px",
                          marginTop: "10px",
                        }}
                      >
                        Agent Test
                      </h6>

                      <div
                        class="widget_wrapper widget_fwrapper active"
                        id="widgetWrapperId"
                      >
                        <iframe
                          src={
                            this.runtimeServer +
                            "/web-widget/widget_chat?instanceId=dheepareeksharitham" +
                            this.state.projectId +
                            "&developerId=" +
                            this.state.developerId
                          }
                          id="widgetiFrame"
                          width="100%"
                          allowfullscreen=""
                          marginwidth="0"
                          allow="geolocation; microphone; "
                          marginheight="0"
                          hspace="0"
                          vspace="0"
                          frameborder="0"
                          scrolling="no"
                          name="dheeChatFrame"
                        ></iframe>
                        <button
                          type="button"
                          class="btn btn-tool clsIframebtn"
                          style={{ display: "none" }}
                        >
                          <svg
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="20px"
                            height="20px"
                            viewBox="0 0 20 20"
                            enable-background="new 0 0 20 20"
                            space="preserve"
                            fill="#000"
                          >
                            <g id="Bounding_Boxes">
                              <g
                                id="ui_x5F_spec_x5F_header_copy_3"
                                display="none"
                              ></g>
                              <path fill="none" d="M0,0h24v24H0V0z"></path>
                            </g>
                            <g id="Sharp">
                              <g
                                id="ui_x5F_spec_x5F_header_copy_4"
                                display="none"
                              ></g>
                              <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41z"></path>
                            </g>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="col-lg-7"
                  style={{ marginTop: "10px", borderRadius: "10px" }}
                >
                  <div className="card_container">
                    <div className="col-lg-12 p-0" id="style-1">
                      <div className="row">
                        <ul
                          className="nav nav-pills mr-auto configNav"
                          style={{ padding: "0.3rem 0rem 0" }}
                        >
                          <li className="nav-item nav-link active show">
                            <h3
                              className="card-title configBoxTitle"
                              onClick={this.onClickDebugInsight}
                              onMouseOut={this.onclickMouseMoveOut}
                            >
                              Debug Insights
                            </h3>
                          </li>
                        </ul>
                        <div
                          Align="right"
                          style={{
                            display: this.state.showMeaningMatchScore
                              ? "block"
                              : "none",
                          }}
                        >
                          <select
                            className="languageIdDropDown"
                            value={this.state.value}
                            id="runTimeDropDown"
                            onChange={this.handleChangeRunTime}
                            style={{
                              width: "170px",
                              height: "30px",
                              borderRadius: "4px",
                              backgroundColor: "#F9F9FB",
                              marginTop: "15px",
                              marginRight: "30px",
                            }}
                          ></select>
                        </div>
                      </div>
                      <div className="container-fluid">
                        {/* Nav tabs */}
                        <div className="tab-class ">
                          <ul className="nav nav-tabs navCluster border-bottom p-0">
                            <Link
                              to="/projectmgmt/test-and-deploy/Test"
                              style={{ textDecoration: "none" }}
                            >
                              <li
                                className="nav-item nav-link"
                                id="parse-output"
                              >
                                {" "}
                                Parse
                              </li>
                            </Link>
                            <Link
                              to="/projectmgmt/test-and-deploy/Test/meaning-match-score"
                              style={{
                                display: this.state.showMeaningMatchScore
                                  ? "block"
                                  : "none",
                                textDecoration: "none",
                              }}
                            >
                              <li
                                className="nav-item nav-link"
                                id="matching-score"
                              >
                                Meaning <br /> Matches
                              </li>
                            </Link>
                            <Link
                              to="/projectmgmt/test-and-deploy/Test/FaqExtraction"
                              style={{ textDecoration: "none" }}
                            >
                              <li className="nav-item nav-link" id="faq-extr">
                                Extract Faq
                              </li>
                            </Link>

                            <Link
                              to="/projectmgmt/test-and-deploy/Test/IntentExtraction"
                              style={{ textDecoration: "none" }}
                            >
                              <li
                                className="nav-item nav-link"
                                id="intent-extr"
                              >
                                Extract Intent
                              </li>
                            </Link>
                            <Link
                              to="/projectmgmt/test-and-deploy/Test/SlotExtraction"
                              style={{ textDecoration: "none" }}
                            >
                              <li className="nav-item nav-link" id="slot-extr">
                                Extract Slot
                              </li>
                            </Link>
                            <Link
                              to="/projectmgmt/test-and-deploy/Test/DocExtraction"
                              style={{ textDecoration: "none" }}
                            >
                              <li className="nav-item nav-link" id="doc-extr">
                                Extract Document
                              </li>
                            </Link>
                          </ul>
                        </div>
                      </div>

                      <div className="card-body p-0">
                        <div className="tab-content col-12 p-0">
                          <Switch>
                            <Route
                              path="/projectmgmt/test-and-deploy/Test/SlotExtraction"
                              component={SlotExtraction}
                            ></Route>
                            <Route
                              path="/projectmgmt/test-and-deploy/Test/DocExtraction"
                              component={DocExtraction}
                            ></Route>
                            <Route
                              path="/projectmgmt/test-and-deploy/Test/IntentExtraction"
                              component={IntentExtraction}
                            ></Route>
                            <Route
                              path="/projectmgmt/test-and-deploy/Test/FaqExtraction"
                              component={FaqExtraction}
                            ></Route>
                            <Route
                              path="/projectmgmt/test-and-deploy/Test/meaning-match-score"
                              component={MeaningMatchScore}
                            ></Route>
                            <Route
                              path="/projectmgmt/test-and-deploy/Test"
                              component={ParseOutput}
                            ></Route>
                          </Switch>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Test;



// WEBPACK FOOTER //
// ./src/projectmgmt/testAndDeploy/Test.js